import type { z } from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { preferredRelationsShipsQuerySchema } from './preferred-relationships-query-schema';

export const preferredRelationsShipsFormSchema = preferredRelationsShipsQuerySchema.omit({ status: true }).extend({
  status: statusFormSchema,
});

export type PreferredRelationsShipsFormSchema = z.infer<typeof preferredRelationsShipsFormSchema>;
